// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MiscellaneousConfiguration_wrapper__txFIX"};